
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { DATA } from '@/config/data';

import formatNumber from '@/shared/filters/format-number';

import { BillOfLadingModel } from '@/models/bill-of-lading';

import orderServices from '@/services/order-service';

@Component
export default class BillOfLading extends Vue {

    @Prop({default: null})
    private depositId!: number;

    private listBillOfLading: BillOfLadingModel[] = [];

    @Watch('depositId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.depositId) {
            await this.loadData();
        }
    }

    private async loadData() {
        const result = await orderServices.getBillOfLading(this.depositId, 1, authProvider.getToken());
        this.listBillOfLading = [];
        if (result && result.status === 200 && result.data.data) {
            const orderCodes = result.data.data.order_codes;
            const orderTransactions = result.data.data.order_transactions;

            for (const item of orderTransactions) {
                const bill = new BillOfLadingModel();
                bill.createdBy = item.CreatedBy;
                bill.createdDate = item.CreatedDate;
                bill.id = item.ID;
                bill.modifiedBy = item.ModifiedBy;
                bill.modifiedDate = item.ModifiedDate;
                bill.orderCodeId = item.OrderCodeID;
                bill.orderId = item.OrderID;
                bill.transactionCode = item.TransactionCode;
                bill.productName = item.ProductName;
                bill.productImage = item.ProductImage ? item.ProductImage : '';
                bill.productAmount = item.ProductAmount;
                bill.numberOfPack = item.NumberOfPack;
                bill.productNumber = item.ProductNumber;
                bill.packageType = item.PackageType;
                bill.status = item.Status;
                bill.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                bill.uId = item.UID;
                bill.userName = item.Username;
                bill.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                bill.weightByVolume = item.WeightByVolume > 0 ? `${formatNumber(item.WeightByVolume, '0,0.[0000]')} kg` : '';
                bill.volume = item.Width > 0 ? `${item.Length}cm x ${item.Width}cm x ${item.Height}cm` : '';
                bill.feeWeight = item.FeeWeight;
                bill.feeWeightAmount = item.FeeWeightAmount;
                this.listBillOfLading.push(bill);
            }
        }
    }
}
